module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "prologue"
    }
  }, [_c('h1', [_vm._v("Prologue")]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-top": "20px",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("1942")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "paris-france"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "padding-bottom": "10px",
      "text-indent": "0px",
      "font-size": "16px",
      "letter-spacing": "1px"
    }
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Along the cobblestoned streets of the French capital city, walked a French businessman dressed in a black pinstriped suit, wearing a black tie, a matching fedora hat and polished Oxford brogue shoes. The man was nervous, constantly straightening his tie. There was a Nazi soldier on every street, treating the man with disdain. Halfway down the main street, the man ducked into a secluded side street and cautiously walked down, constantly checking behind him. He turned a corner and his path was blocked by a tall slim man, wearing a dark blue coat, a grey flat cap and a black armband on his upper left arm. From his thin lips hung an unlit hand-rolled cigarette. The grip of a pistol could be seen sticking out the front of his trousers. The businessman, without a word, held out a small bundle of notes, which was the grand sum of four hundred Francs.")]), _vm._v(" "), _c('p', [_vm._v("The second man quickly grabbed it and passed the man a brown paper bag containing a kilogram of sugar that he had pre-ordered, which he instantly hid beneath his suit jacket. The trade had been completed and the two men went off in opposite directions. This was the second European war and black-market trading was a way of life. The marketeers mostly accepted Francs or Reichsmarks; other currencies were too easily forged. On the very rare occasion they may ask for a favour in return for the trade, from certain people who could provide them with such details as truck supply rotas or warehouse itineraries, information which could be used to stock up their underground economy supplies. Any rationed or illegally obtained products could be purchased for the right price, whether it was forged ration stamps, silk shirts or even firearms. Any man wearing a black armband on his upper arm would get you anything you desired.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0